export const enNodeDisplay = {
  nodeDisplay: {
    sort: 'Sort nodes',
    direction: 'Sort direction',
    asc: 'Ascending',
    desc: 'Descending',
    displayId: 'Display ID',
    name: 'Name (A–Z)',
    cpu: 'CPU',
    memory: 'Memory',
    swap: 'Swap',
    disk: 'Storage',
    network: 'Total network',
    rx: 'Download',
    tx: 'Upload',
    load: 'Load (1 min)',
    latency: 'Latency',
    uptime: 'Session uptime',
    idHint: 'Optional number for ordering. The agent identity stays the same.',
    invalidId: 'Enter a whole number from 0 to 2147483647, or leave blank.',
    country: 'Country / flag',
    automatic: 'Automatic from IP',
    detected: 'Detected country',
    sourceIp: 'Observed IP',
    latencyHint: 'HTTPS round-trip response time measured by the agent.',
    latencyMissing: 'The agent has not reported latency. Update the agent on this node.',
    networkScale: 'Bar length is relative to the busiest node in this list.',
    leaderboard: 'Uptime Leaderboard',
    period: 'Leaderboard period',
    days: '{count} days',
    rank: 'Rank',
    subtitle: 'Heartbeat availability over the selected period; unknown time is shown separately.',
    logoutCallback: 'Logout callback URL',
  },
  secureLogout: {
    title: 'Sign out securely',
    description: 'End your Pulsewatch session and continue to Erauth to sign out there.',
    tokenDescription: 'Clear this browser’s administrator login.',
    action: 'Sign out',
    cancel: 'Stay signed in',
    working: 'Signing out…',
    complete: 'You are signed out',
    done: 'Your Pulsewatch session has ended.',
    providerDone: 'Erauth returned after completing the sign-out flow.',
    providerUnknown: 'You can sign out of Erauth too if its session is still open.',
    return: 'Return to login',
    active: 'This browser still has an active administrator session.',
    checking: 'Checking sign-out status…',
    tokenToggle: 'Sign in with an administrator token',
    sessionHint: 'Erauth secures your login. Use Sign out to end your session.',
  },
}
export const zhNodeDisplay = {
  nodeDisplay: {
    sort: '节点排序',
    direction: '排序方向',
    asc: '升序',
    desc: '降序',
    displayId: '显示 ID',
    name: '名称首字母',
    cpu: 'CPU',
    memory: '内存',
    swap: '交换内存',
    disk: '磁盘',
    network: '总网络速率',
    rx: '下载速率',
    tx: '上传速率',
    load: '一分钟负载',
    latency: '延迟',
    uptime: '本次在线时长',
    idHint: '可选的排序编号，Agent 身份保持不变。',
    invalidId: '请输入 0 至 2147483647 的整数，或留空。',
    country: '国家 / 国旗',
    automatic: '根据 IP 自动识别',
    detected: '识别的国家',
    sourceIp: '观测 IP',
    latencyHint: '由 Agent 测量的 HTTPS 往返响应时间。',
    latencyMissing: 'Agent 尚未上报延迟，请在该节点更新 Agent。',
    networkScale: '条形长度相对当前列表中网络速率最高的节点。',
    leaderboard: '可用率排行榜',
    period: '排行榜时间范围',
    days: '{count} 天',
    rank: '排名',
    subtitle: '按所选时间范围统计心跳可用率，未知时间单独显示。',
    logoutCallback: '退出回调地址',
  },
  secureLogout: {
    title: '安全退出',
    description: '结束 Pulsewatch 会话，并前往 Erauth 完成退出。',
    tokenDescription: '清除当前浏览器的管理员登录。',
    action: '退出登录',
    cancel: '保持登录',
    working: '正在安全退出…',
    complete: '已安全退出',
    done: 'Pulsewatch 会话已结束。',
    providerDone: 'Erauth 已在退出流程后返回。',
    providerUnknown: '如果 Erauth 会话仍然有效，也可以前往 Erauth 退出。',
    return: '返回登录页',
    active: '当前浏览器仍有有效的管理员会话。',
    checking: '正在检查退出状态…',
    tokenToggle: '使用管理员令牌登录',
    sessionHint: '通过 Erauth 安全登录，使用“退出登录”结束会话。',
  },
}
